import { useContext } from "react";
import { UserContext } from "../../App";
import { useParams } from "react-router-dom";
import useAxios from "axios-hooks";
import { UserResDto } from "../../api/Api";
import Members from "../members/Members";
import Classrooms from "../classrooms/Classrooms";

export default function InstructorStudents() {
  const params = useParams();

  const [{ data, loading, error }, getMember] = useAxios<UserResDto>({
    url: `/users/${params.instructorId}`,
  });

  if (loading) {
    return <div></div>;
  }

  return (
    <div>
      <Classrooms
        classroomIds={data?.classrooms.map((classroom: any) => classroom._id)}
      ></Classrooms>
    </div>
  );
}
